/**
 * @generated SignedSource<<50d89105defd9d284b7a85524c4e8ab4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteAssetTrackButtonFragment$data = {
  readonly id: string;
  readonly videoAsset: {
    readonly deleteSubtitleTracks: {
      readonly totalCount: number;
    } | null;
    readonly id: string;
  };
  readonly " $fragmentType": "DeleteAssetTrackButtonFragment";
};
export type DeleteAssetTrackButtonFragment$key = {
  readonly " $data"?: DeleteAssetTrackButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteAssetTrackButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteAssetTrackButtonFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "videoAsset",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "deleteSubtitleTracks",
          "args": null,
          "concreteType": "AssetTrackNodeConnection",
          "kind": "LinkedField",
          "name": "subtitleTracks",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AssetTrack",
  "abstractKey": null
};
})();

(node as any).hash = "2becee171ca44604c7ed627bcff5c613";

export default node;
